import { useCallback, useState } from 'react'
import download from 'downloadjs'

import { wrapCSVTextToBlob, xhrExtractFileName } from 'utils/helpers'
import { getDefaultHeaders } from 'utils/httpUtils'

const CSRF_Token_Header = 'X-CSRFToken'

/**
 * Hook to handle download actions with loading state
 * @returns {{
 *   handleDownloadClick: (args: {
 *     e: React.MouseEvent,
 *     isDisabled?: boolean,
 *     downloadIt?: string | boolean,
 *     downloadObj?: {
 *       method?: string,
 *       url: string,
 *       body?: object,
 *       csv?: boolean
 *     },
 *     href?: string,
 *   }) => void
 * }}
 */
const useDownloadHandler = () => {
  const [isLoading, setIsLoading] = useState(false)

  const handleDownloadClick = useCallback(({ e, isDisabled, downloadIt, downloadObj, href }) => {
    if (isDisabled) return

    if (downloadIt) {
      e.preventDefault()
      download(href, typeof downloadIt === 'string' ? downloadIt : undefined)
      return
    }

    if (downloadObj) {
      e.preventDefault()
      setIsLoading(true)

      const x = new XMLHttpRequest()
      x.open(downloadObj.method || 'GET', downloadObj.url, true)
      x.setRequestHeader(CSRF_Token_Header, getDefaultHeaders()[CSRF_Token_Header])
      x.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      x.responseType = 'blob'

      x.onload = function onLoadDownload(ev) {
        const res = downloadObj.csv ? wrapCSVTextToBlob(ev.target.response) : ev.target.response

        download(res, xhrExtractFileName(x), ev.target.response.type)
        setIsLoading(false)
      }

      x.onerror = () => {
        setIsLoading(false)
      }

      x.send(downloadObj.body ? JSON.stringify(downloadObj.body) : null)
    }
  }, [])

  return { isLoading, handleDownloadClick }
}

export default useDownloadHandler
